import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCustomerEarningsSummary } from 'services/RewardsService'

interface UseCustomerEarningsSummaryQueryOptions {
  currency: string
  enabled?: boolean
}

export const useCustomerEarningsSummaryQuery = ({
  currency,
  enabled = true,
}: UseCustomerEarningsSummaryQueryOptions) => {
  return useQuery({
    queryKey: reactQueryKeys.customerEarningsSummary(currency),
    queryFn: () => getCustomerEarningsSummary({ currency, type: 'CUSTOMER' }),
    enabled: enabled && !!currency,
  })
}
